<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Detalle de padecimientos / tratamiento</h6>
            </template>

            <p v-if="hayAlgunSi" class="text-muted small mb-3">
              Si alguna de las respuestas anteriores es afirmativa para algún miembro del grupo familiar, indique el
              nombre de la persona que la padece, con detalle de la enfermedad y tratamiento que recibe.
            </p>

            <div v-if="hayAlgunSi" class="detalle-por-solicitante">
              <b-card
                v-for="(grupo, gIndex) in detallesPorSolicitante"
                :key="'sol-' + gIndex"
                class="mb-3 detalle-solicitante-card"
              >
                <template #header>
                  <h6 class="mb-0 text-primary">{{ grupo.nombreSolicitante || "Solicitante" }}</h6>
                </template>
                <div class="table-responsive">
                  <table class="table-one tabla-detalle-salud">
                    <thead>
                      <tr>
                        <th>Pregunta</th>
                        <th>Padecimiento o Tratamiento</th>
                        <th>Fecha Inicio <span class="small text-muted">(dd/mm/aaaa)</span></th>
                        <th>Fecha Terminación <span class="small text-muted">(dd/mm/aaaa)</span></th>
                        <th>Médico / Hospital</th>
                        <th style="width: 70px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in grupo.items" :key="item.numPregunta + '-' + index">
                        <td style="display: none">
                          <span>{{item.labelPregunta}}</span>
                        </td>
                        <td class="texto-pregunta">
                          <span class="d-block small">{{ item.labelPregunta || getLabelPregunta(item) }}</span>
                        </td>
                        <td style="width: 30%">
                          <b-form-input
                            v-model="item.padecimientoTratamiento"
                            type="text"
                            :state="getValPadecimientoItem(item)"
                          />
                        </td>
                        <td style="width: 12%">
                          <DateGrid :form="item" name="fechaInicio" />
                        </td>
                        <td style="width: 12%">
                          <DateGrid :form="item" name="fechaFin" />
                        </td>
                        <td>
                          <b-form-input
                            v-model="item.medicoHospital"
                            type="text"                            
                          />
                        </td>
                        <td>
                          <b-btn
                            pill
                            variant="outline-danger"
                            size="sm"
                            @click="borrarDatosItem(item)"
                            >Borrar</b-btn
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card>
            </div>

            <b-alert
              v-if="hayAlgunSi && !todosDetallesCompletos && form.detallesPadecimientos.length"
              show
              variant="warning"
              class="mt-2"
            >
              Complete al menos padecimiento/tratamiento para cada fila indicada.
            </b-alert>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import { PREGUNTAS_CUESTIONARIO_MEDICO } from "@/data/colombia/salud/Selects";
import DateGrid from "@/components/controls/DateGrid.vue";
export default {
  name: "FormColombiaSalud04",
  components: { DateGrid },
  data() {
    return { form: {}, intentoSiguiente: false };
  },
  computed: {
    hayAlgunSi() {
      if (!this.form.beneficiarios || !Array.isArray(this.form.beneficiarios)) return false;
      return this.form.beneficiarios.some((p) => (p.respuestas || []).some((r) => r === "S"));
    },
    detallesPorSolicitante() {
      const list = this.form.detallesPadecimientos || [];
      const byName = {};
      list.forEach((item) => {
        const nom = (item.nombreSolicitante || "").trim() || "Solicitante";
        if (!byName[nom]) byName[nom] = { nombreSolicitante: nom, items: [] };
        byName[nom].items.push(item);
      });
      return Object.values(byName);
    },
    todosDetallesCompletos() {
      if (!this.form.detallesPadecimientos || !this.form.detallesPadecimientos.length) return true;
      return this.form.detallesPadecimientos.every(
        (d) => (d.padecimientoTratamiento || "").trim() !== "" && (d.nombreSolicitante || "").trim() !== ""
      );
    },
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const form = this.$store.state.wizard.form;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/salud/");
      this.$store.dispatch("app/loading", false);
      return;
    }
    this.form = form;
    if (!this.form.detallesPadecimientos) this.form.detallesPadecimientos = [];

    const haySi = (this.form.beneficiarios || []).some((p) =>
      (p.respuestas || []).some((r) => r === "S")
    );

    if (haySi) {
      const existentes = this.form.detallesPadecimientos;
      const list = [];
      (this.form.beneficiarios || []).forEach((persona) => {
        const resp = persona.respuestas || [];
        const nombreSolicitante = persona.name || "";
        resp.forEach((r, idxPregunta) => {
          if (r === "S") {
            const pregunta = PREGUNTAS_CUESTIONARIO_MEDICO[idxPregunta];
            const numPregunta = String(idxPregunta + 1);
            const previo = existentes.find(
              (e) => (e.nombreSolicitante || "") === nombreSolicitante && (e.numPregunta || "") === numPregunta
            );
            list.push({
              numPregunta,
              labelPregunta: pregunta ? pregunta.label : "",
              nombreSolicitante,
              padecimientoTratamiento: previo ? (previo.padecimientoTratamiento || "") : "",
              fechaInicio: previo ? (previo.fechaInicio || "") : "",
              fechaFin: previo ? (previo.fechaFin || "") : "",
              medicoHospital: previo ? (previo.medicoHospital || "") : "",
            });
          }
        });
      });
      this.form.detallesPadecimientos = list.length
        ? list
        : [
            {
              numPregunta: "",
              labelPregunta: "",
              nombreSolicitante: "",
              padecimientoTratamiento: "",
              fechaInicio: "",
              fechaFin: "",
              medicoHospital: "",
            },
          ];
    } else {
      this.form.detallesPadecimientos = [];
    }

    this.form.detallesPadecimientos.forEach((item) => {
      if (item.numPregunta && !item.labelPregunta) {
        const idx = parseInt(item.numPregunta, 10) - 1;
        const pregunta = PREGUNTAS_CUESTIONARIO_MEDICO[idx];
        if (pregunta) item.labelPregunta = pregunta.label;
      }
    });
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 3, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-3.html"));
    },
    borrarDatosItem(item) {
      item.padecimientoTratamiento = "";
      item.fechaInicio = "";
      item.fechaFin = "";
      item.medicoHospital = "";
    },
    getValNombre(index) {
      const d = this.form.detallesPadecimientos[index];
      return (d.nombreSolicitante || "").trim() ? true : false;
    },
    getValPadecimiento(index) {
      const d = this.form.detallesPadecimientos[index];
      return (d.padecimientoTratamiento || "").trim() ? true : false;
    },
    getValPadecimientoItem(item) {
      if (!this.intentoSiguiente) return null;
      return (item.padecimientoTratamiento || "").trim() ? true : false;
    },
    getLabelPregunta(item) {
      if (!item.numPregunta) return "";
      const idx = parseInt(item.numPregunta, 10) - 1;
      const pregunta = PREGUNTAS_CUESTIONARIO_MEDICO[idx];
      return pregunta ? pregunta.label : "";
    },
    next() {
      this.intentoSiguiente = true;
      if (this.hayAlgunSi && !this.todosDetallesCompletos) {
        this.$bvToast.toast("Complete nombre del solicitante y padecimiento/tratamiento en cada fila.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.$store
        .dispatch("wizard/save", { index: 4, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-5.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
}
.tabla-detalle-salud td {
  padding: 0.35rem;
  vertical-align: middle;
}
.texto-pregunta {
  max-width: 320px;
  word-wrap: break-word;
}
.detalle-solicitante-card .card-header {
  background-color: rgba(0, 39, 118, 0.08);
  font-weight: 600;
}
.detalle-solicitante-card .card-header h6 {
  color: var(--one);
}
@media only screen and (max-width: 1000px) {
  .tabla-detalle-salud,
  .tabla-detalle-salud thead,
  .tabla-detalle-salud tbody,
  .tabla-detalle-salud th,
  .tabla-detalle-salud td,
  .tabla-detalle-salud tr {
    display: block;
    position: relative;
  }
  .tabla-detalle-salud thead tr {
    display: none;
  }
  .tabla-detalle-salud tbody tr {
    margin-bottom: 2rem;
    border: 1px solid #dee2e6;
    padding: 1rem;
  }
  .tabla-detalle-salud td {
    border-bottom: 1px solid #eee;
    width: 100% !important;
    padding-top: 1.5rem;
  }
  .tabla-detalle-salud td:first-of-type {
    display: block !important;
    border-bottom: 2px solid var(--primary);
    margin-bottom: 0.5rem;
    padding-top: 0.5rem;
  }
  .tabla-detalle-salud td::before {
    position: absolute;
    top: 4px;
    left: 6px;
    font-weight: bold;
    font-size: 0.85rem;
  }
  .tabla-detalle-salud td:nth-of-type(2):before {
    content: "Pregunta";
  }
  .tabla-detalle-salud td:nth-of-type(3):before {
    content: "Padecimiento o Tratamiento";
  }
  .tabla-detalle-salud td:nth-of-type(4):before {
    content: "Fecha Inicio (dd/mm/aaaa)";
  }
  .tabla-detalle-salud td:nth-of-type(5):before {
    content: "Fecha Terminación (dd/mm/aaaa)";
  }
  .tabla-detalle-salud td:nth-of-type(6):before {
    content: "Médico / Hospital";
  }
  .tabla-detalle-salud td:nth-of-type(7):before {
    content: "";
  }
  .texto-pregunta {    
    display: none !important;
  }
}
</style>
